import React, { PureComponent } from 'react'
import { Trans } from '@lingui/react'

import './store-links.styl'

type Props = {
  show: () => void
}

class StoreLinks extends PureComponent<Props> {
  render() {
    const { show } = this.props

    return (
      <div className="store-links">
        <div>
          <Trans id="book.storelinks" />
        </div>

        <div className="store-links__pseudolink" onClick={show}>
          <Trans id="book.ios" />
        </div>

        <span className="store-links__middot">·</span>

        <div className="store-links__pseudolink" onClick={show}>
          <Trans id="book.android" />
        </div>
      </div>
    )
  }
}

export default StoreLinks
